import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path, Rect } from "react-native-svg";

export const IconConstructionHelmet: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconConstructionHelmet"><Path d="M3.5 14.9999V12.9999C3.5 9.17557 6.02566 5.94111 9.5 4.87354M20.5 14.9999V12.9999C20.5 9.17557 17.9743 5.94111 14.5 4.87354" stroke="currentColor"/><Path d="M9.5 15.5V4.5H14.5V15.5" stroke="currentColor"/><Rect x="2.5" y="15.5" width="19" height="4" stroke="currentColor"/></CentralIconBase>;
});

export default IconConstructionHelmet;
